import React from "react"
import { connect } from "react-redux"
import { Redirect } from "react-router-dom"
import * as actions from "./actions"
import AsyncElements from "../../components/AsyncElements"

class CASContainer extends React.Component {
  componentDidMount() {
    const ticket = (this.props.location.search || "").match(/ticket=(.*)/)[1]
    this.props.dispatch(actions.submitServiceTicket(ticket))
  }

  render() {
    const { isSubmitting, submitError, submitWasSuccessful } = this.props
    if (submitWasSuccessful) {
      const redirectPath = localStorage.getItem("pathToAuthorize") || "/"
      localStorage.removeItem("pathToAuthorize")
      return <Redirect to={redirectPath} />
    } else {
      return (
        <AsyncElements isLoading={isSubmitting} fetchError={submitError}>
          <div>{submitError}</div>
        </AsyncElements>
      )
    }
  }
}

export default connect(state => state.cas)(CASContainer)
